import { useQuery } from '@apollo/client'
import { GET_PATIENT_HISTORY_VALUES } from 'src/legacy/lib/graphql/queries'

export function usePatientHistoryValues(uid: string, type: 'PHQ9' | 'GAD7', orderBy = 'date_ASC') {
  const { data, loading, error } = useQuery(GET_PATIENT_HISTORY_VALUES, {
    variables: { uid, type, orderBy },
  })

  return {
    patientHistory: data?.patientHistory,
    loading,
    error,
  }
}
